// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/loader.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
  position: fixed;
  width: 100%;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.322);
  z-index: 9999;
}
.spinner-container .spinner {
  background: transparent !important;
  width: auto;
  height: auto;
  border-radius: 100%;
  border: 0px !important;
  border-color: transparent !important;
  border-bottom-color: transparent !important;
  display: inline-block;
  animation: auto;
  animation-fill-mode: none;
}
.spinner-container .spinner::after {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  top: 40%;
  width: 100% !important;
  background-size: 151px;
  height: 100% !important;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}`, "",{"version":3,"sources":["webpack://./src/layout/spinner/spinner.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,WAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,4CAAA;EACA,aAAA;AACJ;AACI;EACI,kCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,2CAAA;EACA,qBAAA;EAEA,eAAA;EAEA,yBAAA;AACR;AACQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oEAAA;AACZ","sourcesContent":[".spinner-container {\n    position: fixed;\n    width: 100%;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0.322);\n    z-index: 9999;\n\n    .spinner {\n        background: transparent !important;\n        width: auto;\n        height: auto;\n        border-radius: 100%;\n        border: 0px !important;\n        border-color: transparent !important;\n        border-bottom-color: transparent !important;\n        display: inline-block;\n        -webkit-animation: none;\n        animation: auto;\n        -webkit-animation-fill-mode: both;\n        animation-fill-mode: none;\n\n        &::after {\n            content: \"\";\n            display: block;\n            position: absolute;\n            left: 50%;\n            top: 40%;\n            width: 100% !important;\n            background-size: 151px;\n            height: 100% !important;\n            background-repeat: no-repeat;\n            background-image: url(\"../../assets/images/loader.gif\") !important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
